<template>
	<div id="app">
		<keep-alive>
			<router-view />
		</keep-alive>
	</div>
</template>

<script>

	import {
		mapActions
	} from 'vuex'
	import {
		Blind_box_channel
	} from '@/network/api.js'
	export default {
		name: '',
		data() {
			return {}
		},

		mounted(){
			
		},
		created() {

			if (this._isMobile()) {
				 //window.location.href = '//m.999skins.com'
			}
			// this.$socket.Event(e => {
			// 	sessionStorage.setItem('C_id', e)
			// 	//this.PostBlind_box_channel(e)
			// }).Start()

			//this.$socket.Add('joinGroup', this.JoinGroup)
			//this.$socket.Add('endGroup', this.AddEndGroup)
		},

		methods: {

			//判断访问设备
			_isMobile() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				)
				return flag
			},

			PostBlind_box_channel(e) {
				//Blind_box_channel(e).then(res => {})
			},

			//加入房间
			JoinGroup(data) {
				//this.AddInformation(data)
			},

			//对战结束
			AddEndGroup(data) {
				//this.GetJieShuVsData(data)
			},

			...mapActions([
				'AddInformation',
				'GetJieShuVsData'
			])
		}
	}
</script>

<style lang="scss">
	@import "./styles/bootstrap.css";
    @import "./assets/fonts/font.css";
	* {
		margin: 0;
		padding: 0;
		background: url(/iconfont.svg);
	}

	ul,
	ol {
		list-style: none;
	}



	a {
		text-decoration: none;
	}

	.van-overlay {
		z-index: 100 !important;
	}

	body {
		//background-color: #191919;
		color: #fff;
		font-family: "SansSerif";
	}

	.Title {
		text-align: center;

		p {
			display: inline-block;
			margin: 0 auto;
			color: #fff000;
			font-size: 24px;
			font-weight: 700;
			line-height: 1;
			text-transform: uppercase;
			text-shadow: 0 0 15px hsla(0, 0%, 100%, .5);
			padding: 20px 56px;
			// clip-path: polygon(13px 0, calc(100% - 13px) 0, 100% 50%, calc(100% - 13px) 100%, 13px 100%, 0 50%);
			position: relative;

	
			&::after {
				display: block;
				content: "";
				position: absolute;
				top: 6px;
				left: -60px;
				height: 80%;
				width: 100px;
				background: url(./assets/images/PublicImg/left.svg) no-repeat center;
				background-size: contain;
			}
			&::before {
				display: block;
				content: "";
				position: absolute;
				top: 6px;
				right: -60px;
				height: 80%;
				width: 100px;
				background: url(./assets/images/PublicImg/left.svg) no-repeat center;
				background-size: contain;
				transform: rotate(180deg);
			}
		}
	}
</style>
